/** Shared scroll-reveal for landing sections (see TestimonialFlowSection viewport pattern). */
export const landingMotionInView = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { amount: 0.2, once: true },
  transition: { duration: 0.4 },
} as const;
